import React from "react"
import ReactEcharts from "echarts-for-react"
interface IProps {
    data: any[]
}

const PayrollJobCostingChart: React.SFC<IProps> = (props: IProps) => {
    const option = {
        tooltip: {
            formatter: (params) => {
                return `${params.data.name}: ${params.data.value}%`
            }
        },
        series: [
            {
                type: "pie",
                radius: ["62%", "80%"],
                hoverAnimation: true,
                hoverOffset: 2,
                label: {
                    normal: {
                        position: "insideTopLeft",
                        color: "rgb(97, 97, 97",
                        formatter: (params) => {
                            return `${params.data.ellipsisName} ${params.data.value}%`
                        },
                        fontSize: 11,
                        fontFamily: "Roboto, sans-serif"
                    }
                },
                labelLine: {
                    show: true,
                    length: 5,
                    length2: 4,
                    lineStyle: {
                        color: "rgb(97, 97, 97"
                    }
                },
                data: props.data
            }
        ]
    }
    return <ReactEcharts style={{ height: 175, width: "100%" }} option={option} />
}

export default PayrollJobCostingChart
